<!--主任、顾问首页-->
<template>
    <div class="page-moudle">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <!-- 公告栏 生美 -->
            <van-notice-bar :scrollable="false" v-if="dimension == 1">
                <van-swipe vertical class="notice-swipe" :autoplay="5000" :show-indicators="false">
                    <van-swipe-item v-for="item, index in notices" :key="index">
                        <div class="flex-between flex-y-center font24">
                            <img class="notice-img" src="../../../assets/img/notice_icon.png" alt="">
                            <div class="flex-1">{{ item.desc }}</div>
                            <div class="notice-view-btn flex-y-center" @click="toOtherStore(item.type)">
                                <span>点击查看</span>
                                <img class="notice-arrow" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png">
                            </div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </van-notice-bar>
            <div class="statistics-box  flex-y-center" v-if="postId != '1472787652026765368' && postId != '1472787652026765367' && postId != '1472787652026765441'">
                <img class="statistics-img" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/statistics.png" />
                <div class="statistics-title">会员统计</div>
                <div class="definition-box flex-y-center flex-1 flex-end" @click="toDefinition()">
                    <img class="definition-img" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/definition_description.png" />
                    <div class="definition-title">定义说明</div>
                </div>
            </div>
            <!-- 生美 -->
            <div class="statistics-list flex-y-center" v-if="postId != '1472787652026765368' && postId != '1472787652026765367' && postId != '1472787652026765441' && (dimension == 1 || dimension == 3)">
                <div class="v3-box flex-col flex-1" @click="toMemberStatistics(5)">
                    <span class="v3-name">VVIP</span>
                    <span class="v3-data">{{ masterData.vvip }}</span>
                </div>
                <div class="split-line"></div>
                <div class="v3-box flex-col flex-1" @click="toMemberStatistics(1)">
                    <span class="v3-name">V3</span>
                    <span class="v3-data">{{ masterData.v3 }}</span>
                </div>
                <div class="split-line"></div>
                <div class="high-box flex-col flex-1" @click="toMemberStatistics(2)">
                    <span class="high-name">优质客</span>
                    <span class="high-data">{{ masterData.high }}</span>
                </div>
                <div class="split-line"></div>
                <div class="potential-box flex-col flex-1" @click="toMemberStatistics(3)">
                    <span class="potential-name">高潜力</span>
                    <span class="potential-data">{{ masterData.potential }}</span>
                </div>
                <div class="split-line"></div>
                <div class="basic-box flex-col flex-1" @click="toMemberStatistics(4)">
                    <span class="basic-name">基础客</span>
                    <span class="basic-data">{{ masterData.basics }}</span>
                </div>
            </div>
            <!-- 医美 -->
            <div class="statistics-list-medical flex-col flex-x-center" v-else-if="postId != '1472787652026765368' && postId != '1472787652026765367' && postId != '1472787652026765441' && dimension == 2">
                <div class="item-box flex-between flex-y-center">
                    <div class="basic-box flex-col" @click="toMemberStatistics(1)">
                        <span class="basic-name">VIP</span>
                        <span class="item-data">{{ masterData.vipNum }}</span>
                    </div>
                    <div class="split-line"></div>
                    <div class="basic-box middle flex-col" @click="toMemberStatistics(5)">
                        <span class="basic-name">去年VIP</span>
                        <span class="item-data">{{ masterData.lastYearNum }}</span>
                    </div>
                    <div class="split-line"></div>
                    <div class="basic-box flex-col" @click="toMemberStatistics(6)">
                        <span class="basic-name">今年VIP</span>
                        <span class="item-data">{{ masterData.thisYearNum }}</span>
                    </div>
                </div>
                <div class="item-box flex-between flex-y-center">
                    <div class="basic-box flex-col" @click="toMemberStatistics(2)">
                        <span class="basic-name">高消费</span>
                        <span class="item-data">{{ masterData.highNum }}</span>
                    </div>
                    <div class="split-line"></div>
                    <div class="basic-box middle flex-col" @click="toMemberStatistics(3)">
                        <span class="basic-name">中消费</span>
                        <span class="item-data">{{ masterData.centreNum }}</span>
                    </div>
                    <div class="split-line"></div>
                    <div class="basic-box flex-col" @click="toMemberStatistics(4)">
                        <span class="basic-name">低消费</span>
                        <span class="item-data">{{ masterData.lowNum }}</span>
                    </div>
                </div>
            </div>
            <div class="expire-box  flex-y-center">
                <img class="expire-img" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/expire.png" alt="" />
                <div class="expire-title">本月关注</div>
            </div>
            <div class="expire-list flex-y-center flex-between flex-wrap" v-if="dimension != 3">
                <div class="birthday-box-new flex-y-center flex-start" :class="{ 'hasErp': item.pathName === 'erpRemind', 'erpCls': expireList.some(i => { return i.pathName === 'erpRemind' }) }" v-for="item, index in expireList" :key="index" @click="toExpireItem(item.pathName)">
                    <template>
                        <img v-show="expireList.length === 4" class="expire-icon" :src="item.iconUrl" alt="">
                        <div class="flex-col">
                            <span class="birthday-name">{{ item.title }}</span>
                            <div class="expire-data-box flex-y-center">
                                <span class="expire-data">{{ item.value }}</span>
                                <span v-if="item.pathName !== 'erpRemind'" class="expire-unit">人</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="expire-list flex-y-center" v-else>
                <div class="birthday-box flex-y-center" v-for="item, index in expireList" :key="index" @click="toExpireItem(item.pathName)">
                    <div class="flex-col">
                        <span class="birthday-name">{{ item.title }}</span>
                        <div class="expire-data-box flex-y-center">
                            <span class="expire-data">{{ item.value }}</span>
                            <span class="expire-unit">人</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="briefing-box flex-between flex-y-center">
                <img class="briefing-img" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/briefing.png" alt="" />
                <div class="briefing-title flex-1">本月简报</div>
                <div class="briefing-title-time">数据更新至{{ masterData.newDate }}</div>
            </div>
            <div class="briefing-box-list">
                <div class="flex-y-center flex-wrap">
                    <div class="briefing-list-first flex-col" v-for="item, index in briefingList" :key="index" @click="toBriefingItem(item.pathName)">
                        <div class="tostore-numericalvalue flex-row justify-between">
                            <span class="tostore-percentage">{{ item.rate }}%</span>
                            <span class="tostore-proportion">{{ item.data }}</span>
                        </div>
                        <van-progress class="progress" :color="computedRate(item)" :show-pivot="false" :percentage="item.rate ? item.rate : 0" />
                        <span class="briefing-list-title">{{ item.title }}</span>
                    </div>
                </div>
            </div>
        </van-pull-refresh>
        <van-popup class="definition-popup-box" v-model="definitionShow" closeable close-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/close.png">
            <div class="definition-show-box">
                <div class="definition-head">定义说明</div>
                <div class="definition-content">
                    <div class="member-statistics-box  flex-y-center">
                        <div class="statistics-color"></div>
                        <span class="member-statistics-name">会员统计</span>
                    </div>
                    <div class="statistics-store" v-if="dimension == 1">仅统计卡籍店为本店的客户</div>
                    <div class="statistics-store" v-else-if="dimension == 2">仅统计CP所属门诊为本门诊的客户</div>
                    <div class="statistics-store" v-else-if="dimension == 3">仅统计CP所属门诊为本店的生美客户</div>
                    <div class="member-statistics-box  mt flex-y-center">
                        <div class="statistics-color"></div>
                        <span class="member-statistics-name ">会员分层</span>
                    </div>
                    <div class="definition-name-box flex-col" v-if="dimension == 1 || dimension == 3">
                        <span class="definition-name">1、VVIP：指R12集团消费＞ 10W</span>
                        <span class="definition-name">2、V3：指6.5W＜ R12集团消费 ≤ 10W</span>
                        <span class="definition-name">3、优质客：指3W＜ R12集团消费 ≤ 6.5W</span>
                        <span class="definition-name">4、高潜力：指1W＜ R12集团消费 ≤ 3W</span>
                        <span class="definition-name">5、基础客：指R12集团消费≤ 1W</span>
                    </div>
                    <div class="definition-name-box flex-col" v-else-if="dimension == 2">
                        <span class="definition-name">1、VIP ：医美R12净消费 ≥ 10W</span>
                        <span class="definition-name">2、去年VIP：去年医美净消费 ≥ 10W</span>
                        <span class="definition-name">3、今年VIP：今年医美净消费 ≥ 10W</span>
                        <span class="definition-name">4、高消费 ：指4.7W ≤ 医美R12净消费 &lt; 10W </span>
                        <span class="definition-name">5、中消费：指1.7W ≤ 医美R12净消费 &lt; 4.7W </span>
                        <span class="definition-name">6、低消费：指0W ≤ 医美R12净消费 &lt; 1.7W </span>
                    </div>
                    <div class="definition-remark">注：①R12：指滚动12个月 ②集团消费：指生美、医美、抗衰的净消费额 <span v-show="firstDeptId !== '3'">（不含贝黎诗）</span> ③每月初更新数据（即本月可查看截止到上个月的数据）</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast, Popup, Swipe, NoticeBar } from "vant";
    import { getCookie } from '@/utils'
    import { mapState } from 'vuex'
    import { clickEvt } from "@/utils/util";

    export default {
        props: {
            region: {//一级id
                type: Object,
                default: function () {
                    return {};
                },
            },
            store: {//二级id
                type: Object,
                default: function () {
                    return {};
                },
            },
            notices: {
                type: Array,
                default: function () { return [] }
            }// 公告内容数组
        },
        components: {
            [Popup.name]: Popup,
            [Swipe.name]: Swipe,
            [NoticeBar.name]: NoticeBar,
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
            expireList() { // 本月关注
                if (JSON.parse(localStorage.getItem('employeeInfo')).dimension == 1) {
                    const list = [
                        {
                            title: '生日提醒',
                            value: this.masterData.birthday,
                            pathName: 'birthdayRemind',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-customer.png'
                        },
                        {
                            title: '券/院到期提醒',
                            value: this.masterData.couponStorage,
                            pathName: 'expireRemind',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-quan.png'
                        },
                        {
                            title: '即将进入公共池',
                            value: this.masterData.customerCommonPool,
                            pathName: 'commonPool',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-quan.png'
                        },
                        {
                            title: '积分到期提醒',
                            value: this.masterData.integralNum,
                            pathName: 'newIntegralRemind',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-quan.png'
                        },
                        {
                            title: '库存临期提醒',
                            value: this.masterData.inventoryNum,
                            pathName: 'erpRemind',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-quan.png'
                        }
                    ]
                    if (this.$store.state.app.managerRegin.some(i => { return i == this.postId })) {
                        return list
                    } else {
                        const listNew = list.slice(0, -1)
                        return listNew
                    }
                }
                else if (JSON.parse(localStorage.getItem('employeeInfo')).dimension == 2) {
                    return [
                        {
                            title: '新客',
                            value: this.masterData.newCustomers,
                            pathName: 'newCustomers',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-customer.png'
                        },
                        {
                            title: '生日提醒',
                            value: this.masterData.birthday,
                            pathName: 'birthdayRemind',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-birthday.png'
                        },
                        {
                            title: '券/院到期提醒',
                            value: this.masterData.couponStorage,
                            pathName: 'expireRemind',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-quan.png'
                        },
                        {
                            title: 'C2即将低频',
                            value: this.masterData.c2LowFrequency,
                            pathName: 'c2LowFrequency',
                            iconUrl: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-dipin.png'
                        }
                    ]
                }
                else if (JSON.parse(localStorage.getItem('employeeInfo')).dimension == 3) {
                    return [
                        {
                            title: '新客到诊',
                            value: this.masterData.newCustomers,
                            pathName: 'newCustomers',
                        },
                        {
                            title: '生日提醒',
                            value: this.masterData.birthday,
                            pathName: 'birthdayRemind',
                        },
                        {
                            title: '券余情况',
                            value: this.masterData.couponStorage,
                            pathName: 'ksExpireRemind',
                        }
                    ]
                }

            },
            briefingList() { // 本月简报
                if (JSON.parse(localStorage.getItem('employeeInfo')).dimension == 1) {
                    return [
                        {
                            title: '客户到店率',
                            rate: this.bulletin.theStoreRate,
                            data: this.bulletin.theStoreData,
                            pathName: 'myBooking'
                        },
                        {
                            title: '客户流失率',
                            rate: this.bulletin.loseRate,
                            data: this.bulletin.loseData,
                            pathName: 'customerChurn'
                        },
                        {
                            title: '待办完成率',
                            rate: this.bulletin.backlogRate,
                            data: this.bulletin.backlogData,
                            pathName: 'toDoNewList'
                        },
                        {
                            title: '皮测概览',
                            rate: this.bulletin.sopRate,
                            data: this.bulletin.sopData,
                            pathName: 'piceRegion'
                        }
                    ]
                }
                else if (JSON.parse(localStorage.getItem('employeeInfo')).dimension == 2) {
                    return [
                        {
                            title: '门诊消费来诊率',
                            data: this.bulletin.visitData,
                            rate: this.bulletin.visitRate,
                            pathName: 'outpatientVisit'
                        },
                        {
                            title: '活跃老客复购率',
                            data: this.bulletin.repurchaseData,
                            rate: this.bulletin.repurchaseRate,
                            pathName: 'oldCustomerRepurchase'
                        },
                        {
                            title: '待办完成率',
                            rate: this.bulletin.backlogRate,
                            data: this.bulletin.backlogData,
                            pathName: 'toDoNewList'
                        },
                    ]
                }
                else if (JSON.parse(localStorage.getItem('employeeInfo')).dimension == 3) {
                    return [
                        {
                            title: '铺垫精准来诊率',
                            data: this.bulletin.ksPrepaymentsData,
                            rate: this.bulletin.ksPrepDiagnosisRate,
                            pathName: 'ksOutpatientVisit'
                        },
                        {
                            title: '重点项目达成率',
                            data: this.bulletin.ksReachData,
                            rate: this.bulletin.ksReachRate,
                            pathName: 'keyProjectComplete'
                        },
                        {
                            title: '客户流失率',
                            data: this.bulletin.loseData,
                            rate: this.bulletin.loseRate,
                            pathName: 'ksCustomerChurn'
                        },
                        {
                            title: '有效会员渗透率',
                            data: this.bulletin.ksPermeateData,
                            rate: this.bulletin.ksPermeateRate,
                            pathName: 'ksMemberInfiltrationRegionPage'
                        },
                    ]
                }

            },
            computedRate() {
                return function (item) {
                    if (item) {
                        // 皮测>=90显示绿色，其他>=50显示绿色
                        if (item.pathName === 'piceDirector') {
                            if (Number(item.rate) >= 90) {
                                return '#2FD0D5'
                            } else {
                                return '#ee0a24'
                            }
                        } else {
                            if (Number(item.rate) >= 50) {
                                return '#2FD0D5'
                            } else {
                                return '#ee0a24'
                            }
                        }
                    }
                }
            }
        },
        data() {
            return {
                masterData: {},  //首页数据
                dataDayDTO: [],  //今日数据
                bulletin: [],    //本月简报
                refreshing: false,   //刷新
                postId: 0, // 岗位
                definitionShow: false,   //定义说明
                dimension: 0, //区分生美医美
                firstDeptId:0, //是否是贝黎诗
            };
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
            this.firstDeptId = JSON.parse(localStorage.getItem('employeeInfo')).firstDeptId
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                // overlay: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
            });
            this.onLoad();
        },
        methods: {
            onLoad() {
                let params = null
                if (this.regionPostId.includes(this.postId)) {
                    params = {
                        id: this.region.id,
                        storeId: this.store.id
                    }
                }
                request({
                    url: '/home/index',
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.masterData = res.data;
                        this.dataDayDTO = res.data.dataDayDTO;
                        this.bulletin = res.data.bulletin;
                        // 手动清除 Toast
                        Toast.clear();
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.refreshing = false
                    });
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                this.onLoad();
            },
            //跳转客户流失率
            toCustomerChurn() {
                this.$router.push({ name: "customerChurn", query: {} });
            },
            // 跳转待办
            toDoNewList() {
                if (this.postId == 1 || this.postId == '1472787652026765367' || this.regionPostId.includes(this.postId)) {
                    if (this.store.id != 0 && this.store.id != -1) {
                        this.$router.push({
                            name: 'toDoNewList', query: {
                                id: this.region.id,
                                storeId: this.store.id
                            },
                        });
                    }
                }
                else {
                    this.$router.push({ name: 'todoList', query: {}, });
                }
            },
            //跳转新增客户列表
            toNewCustomer() {
                this.$router.push({ name: 'newCustomersList', query: {}, });
            },
            //跳转客流列表
            toPassengerFlow() {
                this.$router.push({ name: 'passengerFlowList', query: {}, });
            },
            //跳转客户到店
            toMyBooking() {
                this.$router.push({ name: 'myBooking', query: {}, });
            },
            //跳转任务详情
            toDoDetail(todoId) {
                this.$router.push({ name: "toDoDetail", query: { custId: todoId } });
            },
            //跳转新办卡详情
            toNewCardList() {
                this.$router.push({ name: "newCardList", query: {} });
            },
            //跳转sop
            toSopList() {
                this.$router.push({ name: "sopList", query: {} });
            },
            //查看会员统计
            toMemberStatistics(type) {
                if (this.store.id == 0 || this.store.id == -1) {
                    this.$router.push({ name: "memberStatisticsRegionPage", query: { type: type } });
                } else {
                    this.$router.push({ name: "memberStatistics", query: { type: type } });
                }
            },
            // 跳转本月关注--相关
            toExpireItem(pathName) {
                this.$router.push({ name: pathName, query: {} });
            },
            // 跳转本月简报--相关
            toBriefingItem(pathName) {
                if (pathName == 'toDoNewList') {
                    // 客户经理跳转tab的待办，其余的岗位跳转新待办
                    if (this.postId == 42 || this.postId == 2 || this.postId == '1472787652026765441') {
                        this.$router.push({ name: 'todoList', query: {}, });
                    }
                    else {
                        if (this.store.id != 0 && this.store.id != -1) {
                            this.$router.push({
                                name: pathName, query: {
                                    id: this.region.id,
                                    storeId: this.store.id
                                }
                            });
                        }
                    }
                } else if (pathName == 'null') {
                    return
                }
                else if (pathName == 'ksMemberInfiltrationRegionPage') {
                    if ((this.store.id != 0 && this.store.id != -1) || !this.regionPostId.includes(this.postId)) {
                        return
                    } else {
                        this.$router.push({ name: pathName, query: {} });
                    }
                }
                else if (pathName == 'piceRegion') {
                    clickEvt({ clickType: 1, url: this.$route.name ? this.$route.name : this.$route.path })
                    const userInfo = JSON.parse(localStorage.getItem('employeeInfo'));
                    // 主任单门店，取单独字段
                    if (!userInfo.region && !userInfo.store) {
                        return this.$router.push({ name: 'piceDirector', query: { id: userInfo.storeId, storeName: userInfo.storeName } });
                    }
                    // 主任多门店或者区经选中全部门店
                    if (userInfo.store.id == 0 || userInfo.store.id == -1) {
                        // 主任多门店，取单独字段
                        if (!userInfo.region) {
                            return this.$router.push({ name: 'piceDirector', query: { id: userInfo.storeId, storeName: userInfo.storeName } });
                        }
                        // 有区经字段，则是区经
                        this.$router.push({ name: pathName, query: userInfo.region });
                    } else {
                        // 区经选中门店，跳转门店
                        this.$router.push({ name: 'piceDirector', query: userInfo.store });
                    }
                }
                else {
                    this.$router.push({ name: pathName, query: {} });
                }
            },
            //查看定义说明
            toDefinition() {
                this.definitionShow = true;
            },
            //  跳转异店
            toOtherStore(type) {
                this.$router.push({ name: "otherStore", query: { type } });
            }
        },
    }
</script>


<style scoped lang="less">
    .page-moudle {
        height: calc(100vh - 400px);
        padding: 0 30px 10px 30px;
    }

    :deep(.van-notice-bar, .van-notice-bar__content) {
        width: 690px;
        height: 57px;
        background: #fafafe;
        border-radius: 29px;
        margin-bottom: 46px;
    }

    :deep(.van-notice-bar__content) {
        width: 690px;
    }

    .notice-swipe {
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #a5b0b9;

        .notice-img {
            width: 24px;
            height: 23px;
            margin-right: 10px;
        }

        .notice-view-btn {
            width: 120px;
        }

        .notice-arrow {
            width: 15px;
            height: 24px;
            margin-left: 10px;
        }
    }

    .statistics-box {
        padding: 0 0 40px 0;

        .statistics-img {
            width: 40px;
            height: 40px;
        }

        .statistics-title {
            height: 48px;
            font-size: 34px;
            font-weight: 700;
            color: #35434c;
            margin-left: 20px;
        }

        .definition-box {
            align-items: center;
            text-align: center;
        }

        .definition-img {
            width: 26px;
            height: 26px;
        }

        .definition-title {
            // height: 37px;
            font-size: 26px;
            color: #a0acb5;
            margin-left: 10px;
        }
    }

    .statistics-list,
    .statistics-list-medical {
        background-color: rgba(250, 250, 254, 1);
        border-radius: 30px;
        height: 161px;

        .v3-box {
            text-align: center;

            .v3-name {
                height: 37px;
                font-size: 26px;
                color: #a5b0b9;
            }

            .v3-data {
                margin-top: 10px;
                height: 59px;
                font-size: 42px;
                font-weight: 700;
                color: #35434c;
            }
        }

        .high-box {
            text-align: center;

            .high-name {
                height: 37px;
                font-size: 26px;
                color: #a5b0b9;
            }

            .high-data {
                margin-top: 10px;
                height: 59px;
                font-size: 42px;
                font-weight: 700;
                color: #35434c;
            }
        }

        .potential-box {
            text-align: center;

            .potential-name {
                height: 37px;
                font-size: 26px;
                color: #a5b0b9;
            }

            .potential-data {
                margin-top: 10px;
                height: 59px;
                font-size: 42px;
                font-weight: 700;
                color: #35434c;
            }
        }

        .basic-box {
            text-align: center;
            width: 174px;

            .basic-name {
                height: 37px;
                font-size: 26px;
                color: #a5b0b9;
            }

            .basic-data {
                margin-top: 10px;
                height: 59px;
                font-size: 42px;
                font-weight: 700;
                color: #35434c;
            }
        }

        .basic-box.middle {
            width: 253px;
        }

        .split-line {
            width: 2px;
            height: 58px;
            background: #e9e9e9;
            border-radius: 2px;
        }
    }

    .statistics-list-medical {
        background-color: rgba(250, 250, 254, 1);
        border-radius: 30px;
        height: 294px;
        padding: 0 30px;

        .item-box {
            height: 147px;
            border-bottom: 1px solid #e9e9e9;
        }

        .item-box:nth-child(2) {
            border-bottom: none;
        }

        .item-data {
            margin-top: 10px;
            height: 59px;
            font-size: 38px;
            font-weight: 700;
            color: #35434c;
        }
    }

    .expire-box {
        padding: 40px 30px 40px 0;

        .expire-img {
            width: 40px;
            height: 40px;
        }

        .expire-title {
            height: 48px;
            font-size: 34px;
            font-weight: 700;
            color: #35434c;
            margin-left: 20px;
        }
    }

    .expire-list {
        .birthday-box {
            width: 210px;
            height: 152px;
            background: linear-gradient(139deg, #ffffff 0%, #fcf9fb 100%);
            border-radius: 30px;
            border: 1px solid #e8e8ea;
            padding: 23px 20px;

            .birthday-name {
                font-size: 24px;
                color: #35434c;
            }
        }

        .birthday-box-new {
            width: 336px;
            height: 152px;
            background: linear-gradient(139deg, #ffffff 0%, #fcf9fb 100%);
            border-radius: 30px;
            border: 1px solid #e8e8ea;
            padding: 19px 12px;

            .birthday-name {
                font-size: 24px;
                color: #35434c;
            }

        }

        .erpCls {
            width: 210px;
        }

        .hasErp {
            width: 450px;
            padding: 19px 18px;
        }

        .birthday-box:nth-child(2) {
            margin: 0 30px;
        }

        .birthday-box-new {
            margin-bottom: 20px;
        }

        .expire-icon {
            width: 114px;
            height: 114px;
            margin-right: 8px;
        }

        .expire-data-box {
            margin-top: 11px;

            .expire-data {
                height: 65px;
                font-size: 46px;
                font-weight: 700;
                color: #f65252;
            }

            .expire-unit {
                height: 37px;
                font-size: 26px;
                color: #35434c;
                padding: 0 0 0 10px;
            }
        }
    }

    .remind-box {
        height: 80px;
        background-color: rgba(250, 250, 254, 1);
    }

    .remind-content {
        margin: 0 0 0 30px;
    }

    .remind-time {
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        line-height: 37px;
        margin-right: 30px;
    }

    .remind-type {
        color: rgba(246, 82, 82, 1);
        font-size: 26px;
        line-height: 37px;
    }

    .remind-text {
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        line-height: 37px;
    }

    .todayData-img {
        width: 40px;
        height: 40px;
        display: block;
        margin-top: 64px;
    }

    .todayData-box {
        margin-left: 30px;
    }

    .todayData-title {
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        text-align: left;
        margin: 60px 0 0 10px;
        font-weight: 700;
    }

    .todayData-list {
        margin-top: 46px;
    }

    .todayData-list-first-box {
        width: 200px;
        height: 155px;
        background: #fafafe;
        border-radius: 30px;
        margin-left: 30px;
    }

    .todayData-list-box {
        width: 200px;
        height: 155px;
        background: #fafafe;
        border-radius: 30px;
        margin-left: 45px;
    }

    .todayData-list-title {
        color: rgba(160, 172, 181, 1);
        font-size: 28px;
        text-align: center;
        margin-top: 20px;
    }

    .unit {
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        display: flex;
        align-items: flex-end;
        padding-left: 10px;
        padding-bottom: 8px;
    }

    .todayData-list-contens {
        display: flex;
    }

    .todayData-detail-contens {
        padding-top: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .todayData-number {
        color: rgba(53, 67, 76, 1);
        font-size: 46px;
        font-weight: 700;
    }

    .briefing-list-first {
        width: 330px;
        height: 200px;
        background: #ffffff;
        border-radius: 30px;
        border: 1px solid #d8d8d8;
        margin-top: 40px;
    }

    .briefing-list-first:nth-child(odd) {
        margin-right: 30px;
    }

    .briefing-box {
        margin-top: 20px;

        .briefing-img {
            width: 40px;
            height: 40px;
        }

        .briefing-title {
            color: #35434c;
            font-size: 34px;
            font-weight: 700;
            margin-left: 20px;
        }

        .briefing-title-time {
            font-size: 26px;
            color: #a0acb5;
        }
    }

    .briefing-box-list {
        padding-bottom: 40px;
    }

    .tostore-numericalvalue {
        margin: 30px 0 0 30px;
    }

    .tostore-percentage {
        color: rgba(53, 67, 76, 1);
        font-size: 50px;
        line-height: 70px;
        font-weight: 700;
    }

    .tostore-proportion {
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        line-height: 37px;
        margin: 25px 0 0 10px;
    }

    .progress {
        width: 270px;
        margin: 13px 0 0 30px;
    }

    .briefing-list-title {
        font-size: 26px;
        color: #a0acb5;
        margin: 10px 0 0 30px;
    }

    .ml {
        margin-left: 30px;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    :deep(.van-icon-arrow) {
        font-size: 15px !important;
        margin: 13px 0 9px 10px !important;
        color: #4d5961 !important;
    }

    :deep(.van-popup--center) {
        top: 40% !important;
    }

    .definition-popup-box {
        width: 630px;
        min-height: 682px;
        background: #ffffff;
        border-radius: 16px;

        .definition-show-box {
            .definition-head {
                width: 630px;
                height: 116px;
                background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/definition_top.png) 100% no-repeat;
                background-size: 100% 100%;
                font-size: 36px;
                font-weight: 700;
                color: #35434c;
                text-align: center;
                padding-top: 42px;
            }

            .definition-content {
                padding: 16px 40px 80px 40px;

                .statistics-color {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background: #a3b3d0;
                }

                .member-statistics-name {
                    height: 28px;
                    font-size: 28px;
                    font-weight: 700;
                    color: #35434c;
                    line-height: 28px;
                    margin-left: 10px;
                }

                .statistics-store {
                    height: 36px;
                    font-size: 24px;
                    color: #66757f;
                    line-height: 36px;
                    margin-top: 20px;
                }

                .mt {
                    margin-top: 50px;
                }

                .definition-name-box {
                    margin-top: 20px;
                }

                .definition-name {
                    font-size: 24px;
                    color: #66757f;
                }

                .definition-remark {
                    font-size: 24px;
                    color: #66757f;
                    margin-top: 52px;
                }
            }
        }
    }

    :deep(.van-popup) {
        overflow-y: visible !important;
    }

    :deep(.van-popup__close-icon--top-right) {
        top: 105% !important;
        right: 45% !important;
    }

    :deep(.van-icon__image) {
        width: 56px !important;
        height: 56px !important;
    }
</style>
